import { AutocompleteProps, default as MuiBaseAutocomplete } from '@mui/material/Autocomplete'

import { COLORS, styled, uiTokens } from '../../theme'
import { createComponentWrapperWithRef, THEME_CONST } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

const MuiAutocomplete: MsdkStyledComponent<
  AutocompleteProps<any, boolean | undefined, boolean | undefined, boolean | undefined>
> = styled(MuiBaseAutocomplete)`
  .MuiInputBase-root {
    border-radius: ${THEME_CONST.inputBorderRadius}px;
  }
`

export const Autocomplete = createComponentWrapperWithRef<
  AutocompleteProps<any, boolean | undefined, boolean | undefined, boolean | undefined>
>(
  {
    mui: MuiAutocomplete,
    nova: MuiBaseAutocomplete,
    novaProps: {
      sx: {
        '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
          borderColor: `${COLORS.components.input.readonlyBorder}!important`,
        },
      },
      componentsProps: {
        paper: {
          sx: {
            borderRadius: `${uiTokens.radius.large}px`,
            paddingLeft: `${uiTokens.spacing.padding.small}px`,
            paddingRight: `${uiTokens.spacing.padding.small}px`,
            color: uiTokens.uiStroke.accent,
            fontFamily: `${uiTokens.font.fontFamily.default}`,
            '& .MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused': {
              backgroundColor: COLORS.action.hover,
              borderRadius: `${uiTokens.radius.medium}px`,
              fontWeight: uiTokens.font.fontWeight.medium,
              color: uiTokens.uiContent.emphasized,
            },
          },
        },
        popupIndicator: {
          sx: {
            color: uiTokens.uiStroke.accent,
          },
        },
        clearIndicator: {
          sx: {
            color: uiTokens.uiStroke.accent,
          },
        },
      },
    },
  },
  'Autocomplete',
)
